const isValidDate = (dateString) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) return false;
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date);
};

export const validateChecklist = (formData) => {
  const errors = {};

  // Validate required fields
  const requiredFields = [
    'vehicle_number', 
    'driver', 
    'date', 
    'current_odometer', 
    'previous_odometer', 
    'license_plate_number'
  ];
  requiredFields.forEach(field => {
    if (!formData[field]) {
      errors[field] = 'This field is required';
    }
  });

  // Validate odometer readings and miles traveled
  if (parseInt(formData.current_odometer) <= parseInt(formData.previous_odometer)) {
    errors.current_odometer = 'Current odometer must be greater than previous odometer';
  }
  
  // Validate license plate number
  if (formData.license_plate_number && formData.license_plate_number.length < 2) {
    errors.license_plate_number = 'License plate number must be at least 2 characters long';
  }

  // Validate date fields
  const dateFields = [
    'date', 
    'oil_change_next_date', 
    'fire_extinguisher_cert_date', 
    'safety_kit_eye_wash_expiry', 
    'tire_rotation_date', 
    'engine_tuneup_date', 
    'transmission_service_date', 
    'registration_expiry'
  ];
  dateFields.forEach(field => {
    if (formData[field] && !isValidDate(formData[field])) {
      errors[field] = 'Invalid date format (YYYY-MM-DD)';
    }
  });

  // Validate tire pressure (must be positive numbers)
  const tirePressureFields = ['tire_pressure_lf', 'tire_pressure_rf', 'tire_pressure_lr', 'tire_pressure_rr'];
  tirePressureFields.forEach(field => {
    if (formData[field] && (isNaN(formData[field]) || parseFloat(formData[field]) <= 0)) {
      errors[field] = 'Tire pressure must be a positive number';
    }
  });

  // Validate boolean fields
  const booleanFields = [
    'oil_level',
    'antifreeze_level',
    'windshield_fluid',
    'transmission_fluid',
    'brake_fluid',
    'tire_tread',
    'fan_belt',
    'headlights',
    'taillights',
    'brake_lights',
    'running_lights',
    'turn_signals',
    'emergency_flashers',
    'registration',
    'insurance',
    'fire_extinguisher',
    'fire_extinguisher_charged',
    'safety_kit_flags',
    'safety_kit_first_aid',
    'safety_kit_eye_wash',
    'safety_kit_flares',
    'safety_kit_gloves',
    'safety_kit_hard_hat',
    'safety_kit_goggles',
    'safety_kit_caution_tape',
    'safety_kit_cones',
    'safety_kit_harness',
    'exterior_condition',
    'interior_vacuumed',
    'interior_condition',
    'sanitizing_supplies',
    'extension_cords',
    'tire_traction_devices'
  ];
  booleanFields.forEach(field => {
    if (formData[field] !== true && formData[field] !== false) {
      errors[field] = 'This field must be true or false';
    }
  });

  // Validate appearance
  if (formData.appearance && !['clean', 'dirty'].includes(formData.appearance.toLowerCase())) {
    errors.appearance = 'Appearance must be either "clean" or "dirty"';
  }

  // Validate notes (optional, but if provided, should not be too long)
  if (formData.notes && formData.notes.length > 1000) {
    errors.notes = 'Notes should not exceed 1000 characters';
  }

  // Validate technician signature
  if (!formData.tech_signature) {
    errors.tech_signature = 'Technician signature is required';
  } else if (formData.tech_signature.length < 2) {
    errors.tech_signature = 'Technician signature should be at least 2 characters long';
  }

  return errors;
};